import type { ComponentProps } from 'react';

const DownwardArrowIcon = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.46894 17.2522C9.60567 17.4096 9.79709 17.5 9.99762 17.5C10.1982 17.5 10.3865 17.4096 10.5263 17.2522L15.6307 12.5033C15.9103 12.1819 15.8981 11.673 15.6064 11.3683C15.3147 11.0636 14.8529 11.0737 14.5764 11.3951L10.7268 14.6908L10.7268 3.30357C10.7268 2.85826 10.4017 2.5 9.99762 2.5C9.59352 2.5 9.26841 2.85826 9.26841 3.30357L9.26841 14.6908L5.42176 11.3917C5.14223 11.0703 4.68343 11.0603 4.39175 11.365C4.10006 11.6696 4.09095 12.1786 4.36744 12.5L9.46894 17.2522Z"
      fill="#8C98AB"
    />
  </svg>
);

export default DownwardArrowIcon;
